var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUmbrella(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121_2940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.21125 8.55661L13.5931 10.8804C15.7925 5.78411 18.9812 1.86223 22.2806 0.0241056C16.2881 -0.281519 10.4819 2.33411 6.7475 7.01161C6.32937 7.53661 6.58125 8.32723 7.21125 8.55661ZM15.4769 11.5666L30.3819 16.9935C32.6169 9.40723 31.5506 2.51473 27.7175 1.11973C27.255 0.950981 26.7719 0.869731 26.2744 0.869731C22.6481 0.870356 18.2575 5.19286 15.4769 11.5666ZM32.5925 3.78161C32.9812 4.80036 33.2694 5.94411 33.4175 7.23098C33.7762 10.3491 33.3288 13.9954 32.2331 17.6672L38.6469 20.0022C39.2775 20.2316 39.9787 19.7879 39.995 19.1166C40.14 13.136 37.3756 7.40161 32.5925 3.78161ZM35 27.9991H20.0662L24.125 16.8441L20.3662 15.4754L15.81 27.9985H1C0.4475 27.9985 0 28.446 0 28.9991V30.9997C0 31.5522 0.4475 32.0004 1 32.0004H35C35.5525 32.0004 36 31.5522 36 30.9997V28.9991C36 28.4466 35.5525 27.9991 35 27.9991Z",
    fill: "#6B7A7F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_2940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrella);
export default __webpack_public_path__ + "static/media/umbrella.b6b92c6215597ad7cb2e2dce610a0e3f.svg";
export { ForwardRef as ReactComponent };